import { render, staticRenderFns } from "./DashboardSkeleton.vue?vue&type=template&id=6452f040&scoped=true"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardSkeleton.vue?vue&type=style&index=0&id=6452f040&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452f040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6452f040')) {
      api.createRecord('6452f040', component.options)
    } else {
      api.reload('6452f040', component.options)
    }
    module.hot.accept("./DashboardSkeleton.vue?vue&type=template&id=6452f040&scoped=true", function () {
      api.rerender('6452f040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/DashboardSkeleton.vue"
export default component.exports